import React from 'react';
import { Link } from 'react-router-dom';

function NoResult() {
  return (
    <div className="row barplot-results">
      <div className="col">
        <div className="card">
          <div className="card-header">
            Results
          </div>
          <div className="card-body">
            <p>There were no gene names in the dataset that match your search query. Please try a less specific search filter. If you still can&apos;t find your gene of interest, please see our <Link to="/about#geneselection">methods section</Link> for information about our gene selection process.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NoResult;



// WEBPACK FOOTER //
// ./src/components/NoResult.jsx